t = require('views/internal/teacup-with-helpers')('org_detail')

module.exports = t.renderable (data) ->
  { name, editable, logoHash, isEnterprise, paysWithPurchaseOrder,
    isBusinessClassAdmin, isInOrg, isOrgAdmin, hasAccount, accountProblem,
    isFullWidth, hasUnlimitedPowerUps, upsellEnabled } = data

  t.div '.tabbed-pane-header', ->
    t.div '.tabbed-pane-header-wrapper.u-clearfix', ->
      t.div '.tabbed-pane-header-content', ->

        t.a class: t.classify('tabbed-pane-header-image': true, 'profile-image': true, 'is-editable': editable, 'js-change-org-logo': editable), href: '#', ->
          if logoHash
            t.img '.profile-image-image', src: [logoDomain, logoHash, '170.png'].join('/')
          else
            t.span '.profile-image-icon.icon-lg.icon-organization'
          t.span '.profile-image-change-text', ->
            t.format 'change-logo'

        t.div '.tabbed-pane-header-details', ->
          t.div '.js-current-details'

          if editable
            t.form '.js-profile-form.hide'

  t.div '.tabbed-pane-nav.u-clearfix', ->

    t.ul ->

      t.li '.tabbed-pane-nav-item', ->
        t.a '.tabbed-pane-nav-item-button.js-org-profile', 'data-tab': 'boards', href: ['', name].join('/'), ->
          t.format 'boards'

      t.li '.tabbed-pane-nav-item', ->
        t.a '.tabbed-pane-nav-item-button.js-org-members', 'data-tab': 'members', href: ['', name, 'members'].join('/'), ->
          t.format 'members'

      if isBusinessClassAdmin
        t.li '.tabbed-pane-nav-item', ->
          t.a '.tabbed-pane-nav-item-button.js-org-export', 'data-tab': 'export', href: ['', name, 'export'].join('/'), ->
            t.icon 'business-class'
            t.format 'export'

      if isInOrg
        t.li '.tabbed-pane-nav-item', ->
          t.a '.tabbed-pane-nav-item-button.js-org-account', 'data-tab': 'settings', href: ['', name, 'account'].join('/'), ->
            t.format 'settings'

      if isInOrg && !isEnterprise && !paysWithPurchaseOrder && upsellEnabled
        billingUrl = ['', name, 'billing'].join('/')
        t.li '.tabbed-pane-nav-item', ->
          if hasAccount
            if accountProblem
              t.a '.tabbed-pane-nav-item-button.js-billing', 'data-tab': 'billing-issue', href: billingUrl, ->
                t.format 'billing-issue'
            else
              t.a '.tabbed-pane-nav-item-button.js-billing', 'data-tab': 'billing', href: billingUrl, ->
                t.format 'billing'
          else if !hasUnlimitedPowerUps
            t.a '.tabbed-pane-nav-item-button.dark-hover.js-billing', 'data-tab': 'business-class', href: billingUrl, ->
              t.span '.icon-sm.icon-business-class.mod-inline.icon-business-class-color'
              t.text ' '
              t.format 'business class'
      return

  t.div '.tabbed-pane-main-col.u-clearfix', ->
    t.div '.tabbed-pane-main-col-loading.hide.js-loading-page', ->
      t.span '.tabbed-pane-main-col-loading-spinner.spinner'
    t.div class: t.classify('tabbed-pane-main-col-wrapper': true, 'js-content': true, 'is-full-width': isFullWidth)



// WEBPACK FOOTER //
// ./app/scripts/views/templates/org_detail.coffee